import { Grid, InputLabel, TextField } from '@material-ui/core'
import { formatCustomDate } from 'helpers/dateTools'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export const UnitCS = ({ data }) => {
  const { stations } = useSelector(state => state.companies)
  const { units } = useSelector(state => state.unitsReducer)

  const [unitData, setUnitData] = useState({})
  const { unit, station, date } = unitData
  useEffect(() => {
    setUnitData({
      unit: data?.unit ? data.unit : units[data.route]?.number,
      station: stations[data.idStation]?.name ? stations[data.idStation]?.name : data.station,
      date: formatCustomDate(new Date())
    })
  }, [data, stations, units])
  
  return (
    <Grid container spacing={1} style={{
      marginBottom: 30
    }}>
        <Grid item xs={4}>
          <InputLabel>Planta:</InputLabel>
          <TextField 
            variant='outlined'
            // label="Empresa"
            name="station"
            value={station}
            disabled
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
        <InputLabel>Unidad:</InputLabel>
          <TextField 
            variant='outlined'
            name="unit"
            value={unit}
            disabled
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
        <InputLabel>Fecha:</InputLabel>
          <TextField 
            variant='outlined'
            name="date"
            value={date}
            disabled
            fullWidth
          />
        </Grid>
      </Grid>
  )
}
